import { useRef } from 'react';

/** Client-only identity: keep local input state with its row, without storing UI fields. */
export function createRowKeys() {
  const keys = new WeakMap();
  let next = 0;
  const key = row => {
    if (!keys.has(row)) keys.set(row, `row-${++next}`);
    return keys.get(row);
  };
  return {
    key,
    replace: (previous, replacement) => {
      keys.set(replacement, key(previous));
      return replacement;
    }
  };
}
export default function useRowKeys() {
  const keys = useRef(null);
  if (!keys.current) keys.current = createRowKeys();
  return keys.current;
}
